export default __webpack_public_path__ + "ea7ec9375927896bff35f855d8cfc6d0.svg";